/**
 * The sky, as words (M3-05) — the prose behind the HUD strip's clock (RC2-07).
 *
 * One discipline, unchanged since M3-05: **no numbers**. "sodden" rather than
 * 0.71, and "you can barely see your hands" rather than a sight radius of three.
 *
 * The clock is the one exception, and it earns it: a player planning to be off
 * the moor before dark has to be able to ask how long they have, and "the light
 * is going" does not answer that. `formatGameClock` is the sim's own spelling of
 * the time, so the strip and the log stamp agree.
 *
 * ## What RC2-07 retired
 *
 * This used to own a strip of its own — a `SkyLine` class writing three spans
 * into a corner of the overlay — and a `skyLineView` that composed the whole
 * line, including a camp clause about where you were standing. The approved HUD
 * puts the clock in the status strip and the camp on a `StatusTag`, so the DOM
 * renderer and the composite view are gone and what is left is what everything
 * else was already using: the prose rules, pure and tested.
 */

/** How wet the ground is, as a word. */
export function wetnessProse(wetness: number): string {
  if (wetness >= 0.75) return 'sodden';
  if (wetness >= 0.45) return 'wet through';
  if (wetness >= 0.2) return 'damp';
  return 'dry';
}

/**
 * How much you can see, as a clause — derived from the radius rather than
 * printed, because "3" is a number and "barely your hands" is a warning.
 */
export function sightProse(sight: number): string | null {
  if (sight <= 3) return 'You can barely see your own hands';
  if (sight <= 8) return 'You can see about as far as a thrown stone';
  if (sight <= 16) return 'The far bank is a guess';
  return null;
}
